import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m7.65 4.677 13.106-.722a.813.813 0 0 1 .857.767l.7 12.718c.084 1.498-1.92 3.311-4.382 2.245-3.078-1.332-1.219-3.939.334-3.023s2.8 5.354-2.72 5.158m-9.924.547 5.43-.3"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M2.396 19.479 1.632 5.622a3.061 3.061 0 0 1 6.113-.337l.764 13.857"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M5.621 22.367a3.061 3.061 0 1 0-.337-6.113 3.061 3.061 0 0 0 .337 6.113"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.213 19.99a1.02 1.02 0 1 0-1.52-1.36 1.02 1.02 0 0 0 1.52 1.36"
    />
  </svg>
);
export const OnlineTrainerIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
